<!-- eslint-disable vue/no-v-for-template-key-on-child -->
<template>
  <GenericButton
    v-bind="{ ...$props, ...$attrs }"
    class="text-white hover:bg-primary30 focus:outline-none focus:bg-primary"
  >
    <template v-for="(_, slot) of $slots" v-slot:[slot]="scope">
      <slot :key="slot" :name="slot" v-bind="scope" />
    </template>
  </GenericButton>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import GenericButton from '@/components/designSystem/Buttons/GenericButton/index.vue'

export default defineComponent({
  extends: GenericButton,
  inheritAttrs: false,
  components: {
    GenericButton
  },
  props: {
    icon: { type: Boolean, default: false },
    text: { type: String, default: 'Button' },
    width: { type: String, default: '300px' },
    color: { type: String, default: 'primary20' },
    disabled: { type: Boolean, default: false }
  },
  setup() {
    return {}
  }
})
</script>
<style scoped></style>
